import { render, staticRenderFns } from "./FloatButtonComponent.vue?vue&type=template&id=05c13244&scoped=true&"
import script from "./FloatButtonComponent.vue?vue&type=script&lang=js&"
export * from "./FloatButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./FloatButtonComponent.vue?vue&type=style&index=0&id=05c13244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c13244",
  null
  
)

export default component.exports